// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"DraftPurchaseOrders_sectionWrapper__3syi0"};